import { motion } from "motion/react"
import { FormattedMessage } from "react-intl";
import { ANDROID_VERSION, APP_STORE_LINK, DEBIAN_VERSION, GOOGLE_PLAY_LINK, IOS_VERSION, MAC_VERSION, UBUNTU_VERSION, WINDOWS_VERSION } from "../privacy/constants";

export default function PageThree() {
    return (
        <motion.div
        className="mainScrollBaseContainer"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.5 }}
        >
            <div className="centered main heightCenter">
                <div className="horizontal">
                    <div className="featureCard centered">
                        <h2><FormattedMessage id="windows" /></h2>
                        <div className="exampleDeviceWrapper">
                            <div className="winBg">
                                <img src="assets/pb_icon.png" alt=""/>
                            </div>
                            <img src="assets/desktop_filled_full.png" className="desktopImage" alt=""/>
                        </div>
                        <FormattedMessage id="windowsVersions" values={{version: WINDOWS_VERSION}}/>
                    </div>
                    <div className="featureCard centered">
                        <h2><FormattedMessage id="macos" /></h2>
                        <div className="exampleDeviceWrapper">
                            <div className="macBg">
                                <img src="assets/pb_icon.png" alt=""/>
                            </div>
                            <img src="assets/mac.svg" className="desktopImage mac" alt=""/>
                        </div>
                        <FormattedMessage id="macosVersions" values={{version: MAC_VERSION}} />
                    </div>
                    <div className="featureCard centered">
                        <h2><FormattedMessage id="linux" /></h2>
                        <div className="exampleDeviceWrapper">
                            <div className="linBg">
                                <img src="assets/pb_icon.png" alt=""/>
                            </div>
                            <img src="assets/pc.svg" className="desktopImage" alt=""/>
                        </div>
                        <FormattedMessage id="linuxVersions" values={{debversion: DEBIAN_VERSION, ubuversion: UBUNTU_VERSION}} />
                    </div>
                </div>
                <div className="horizontal">
                    <div className="featureCard centered">
                        <h2><FormattedMessage id="android" /></h2>
                        <div className="exampleDeviceWrapper">
                            <div className="mobileBG androidBg">
                                <img src="assets/pb_icon.png" alt=""/>
                            </div>
                            <img src="assets/android_filled.png" className="mobileImage" alt=""/>
                        </div>
                        <FormattedMessage id="androidVersions" values={{version: ANDROID_VERSION}}/>
                        <a href={GOOGLE_PLAY_LINK} target="_blank" rel="noreferrer">
                            <img className="storeLink" src="assets/GetItOnGooglePlay_Badge_Web_color_English.png" alt=""/>
                        </a>
                    </div>
                    <div className="featureCard centered">
                        <h2><FormattedMessage id="ios" /></h2>
                        <div className="exampleDeviceWrapper">
                            <div className="mobileBG iosBg">
                                <img src="assets/pb_icon.png" alt=""/>
                            </div>
                            <img src="assets/ios.png" className="mobileImage" alt=""/>
                        </div>
                        <FormattedMessage id="iosVersions" values={{version: IOS_VERSION}}/>
                        <a href={APP_STORE_LINK} target="_blank" rel="noreferrer">
                            <img className="storeLink" src="assets/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt=""/>
                        </a>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}